<template>
  <div class="sudi-item-container">
    <custom-router-link :item="info" class="sudi-item-link" :to="{name: 'SudiDetails', params: {id: info.id}}" target="_blank">
      <div class="sudi-item-image">
        <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
        <el-image :src="require('@/assets/images/img3.png')" fit="cover" v-else></el-image>
      </div>
      <div class="sudi-item-details">
        <div class="sudi-item-title">{{info.name}}</div>
        <!-- <div class="sudi-item-summary">{{info.summary}}</div>
        <div class="sudi-item-more">
          <div class="publish-time">{{info.publishTime && info.publishTime.split(" ")[0]}}</div>
          <div class="more-info">
            <span>了解更多&nbsp;<i class="el-icon-right"></i></span>
          </div>
        </div> -->
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.sudi-item-container {
  width: 100%;
  .sudi-item-link {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.02);
    .sudi-item-image {
      width: 100%;
      height: 400px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .sudi-item-details {
      width: 100%;
      padding: 14px;
      .sudi-item-title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 10px;
        color: #212529;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .sudi-item-summary {
        width: 100%;
        font-size: 15px;
        color: #6c757d;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    .publish-time {
      font-size: 14px;
      line-height: 22px;
      color: #6c757d;
      margin-top: 10px;
    }
    .sudi-item-more {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #6c757d;
    }
    .more-info {
      display: flex;
      font-size: 16px;
      color: #212529;
      line-height: 32px;
      span {
        border-bottom: 2px solid #2960a7;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .sudi-item-container {
    .sudi-item-link {
      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.04);
      .sudi-item-image {
        width: 100%;
        height: auto;
        aspect-ratio: 5/8;
        overflow: hidden;
      }
      .sudi-item-details {
        .sudi-item-title {
          font-size: 18px;
          line-height: 24px;
          margin-bottom: 6px;
        }
      }
      .publish-time {
        font-size: 12px;
        line-height: 22px;
        color: #6c757d;
        margin-top: 10px;
      }
      .sudi-item-more {
        padding: 14px 0;
      }
      .more-info {
        display: flex;
        font-size: 12px;
        color: #212529;
        line-height: 24px;
        span {
          border-bottom: 1px solid #2960a7;
          font-weight: 600;
        }
      }
    }
  }
}
</style>